// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jz-0";
export var buttonContainer = "_jz-3";
export var cancelButton = "_jz-4";
export var headerSection = "_jz-6";
export var headerTitle = "_jz-9";
export var messageSideLeft = "_jz-1";
export var messageSideRight = "_jz-2";
export var orderNumberContainer = "_jz-7";
export var orderNumberLabel = "_jz-8";
export var submitButton = "_jz-5";